// Timeline data — Sirah Nabawiyah (Sejarah Rasulullah SAW)
// Fully in Bahasa Indonesia. Tone: reflektif, "kita".

export const timelineData = [
  {
    id: "571",
    watermark: "571",
    phaseNumber: "Fase 01",
    title: "Pra-Kenabian",
    subtitle: "Kelahiran hingga Pernikahan",
    period: "Tahun Gajah — 25 Tahun",
    image:
      "https://images.unsplash.com/photo-1638024510305-c36fcc0bf3b1?auto=format&fit=crop&w=1920&q=80",
    intro:
      "Mari kita mulai dari sebuah malam di kota Mekkah, ketika dunia belum mengenal cahaya yang akan mengubahnya selamanya.",
    events: [
      {
        title: "Kelahiran Sang Nabi",
        date: "Senin, 9 Rabi'ul Awwal — Tahun Gajah (20/22 April 571 M)",
        body:
          "Beliau lahir di Mekkah pada Senin pagi di Tahun Gajah. Abdul Muthallib membawa cucunya ke dalam Ka'bah, lalu memberi nama Muhammad — sebuah nama yang asing bagi bangsa Arab kala itu. Pada hari ke-7, beliau dikhitan sebagaimana tradisi keluarga mulia.",
      },
      {
        title: "Susuan dan Masa Kecil di Pedalaman",
        date: "Bani Sa'ad — Tsuwaibah & Halimah As-Sa'diyah",
        body:
          "Disusui pertama kali oleh Tsuwaibah, lalu diserahkan kepada Halimah As-Sa'diyah di Bani Sa'ad. Pada usia 4 atau 5 tahun, peristiwa pembelahan dada terjadi. Di usia 6 tahun, ibunda Aminah wafat di Abwa'. Dua tahun setelahnya, kakek beliau Abdul Muthallib menyusul. Pengasuhan kemudian dilanjutkan oleh paman tercinta, Abu Thalib.",
      },
      {
        title: "Remaja, Penggembala, dan Pedagang",
        date: "Usia 12 — 15 Tahun",
        body:
          "Pada usia 12 tahun beliau diajak Abu Thalib berdagang ke negeri Syam, dan di sinilah Rahib Bahira mengenali tanda-tanda kenabiannya. Di usia 15 tahun beliau ikut serta dalam Perang Fijar. Beliau juga menggembala kambing dengan upah beberapa dinar — sebuah pengalaman yang tak pernah luput dari pemimpin para Nabi.",
      },
      {
        title: "Pernikahan dengan Khadijah",
        date: "Usia 25 Tahun — Maskawin 20 Ekor Unta Muda",
        body:
          "Membawa barang dagangan Khadijah, beliau mendapatkan keuntungan yang berlimpah dan kepercayaan yang lebih dalam. Pernikahan suci pun terjalin dengan Khadijah yang berusia 40 tahun. Dari rahimnya lahir 2 putra (yang wafat di usia kecil) dan 4 putri yang menjadi penerus garis keturunan Nabawiyah.",
      },
      {
        title: "Renovasi Ka'bah dan Hajar Aswad",
        date: "Usia 35 Tahun",
        body:
          "Saat Quraisy hampir berperang memperebutkan kehormatan meletakkan kembali Hajar Aswad, Al-Amin terpilih sebagai penengah. Beliau membentangkan kainnya, meletakkan batu mulia itu di atasnya, lalu meminta setiap pemuka kabilah memegang ujung kain — sebuah keadilan yang menyelamatkan banyak darah.",
      },
    ],
  },
  {
    id: "610",
    watermark: "610",
    phaseNumber: "Fase 02",
    title: "Kenabian di Mekkah",
    subtitle: "Wahyu Pertama hingga Hijrah",
    period: "13 Tahun — Cahaya di Tengah Gelap",
    image:
      "https://images.unsplash.com/photo-1622983473068-37c2e7d04432?auto=format&fit=crop&w=1920&q=80",
    intro:
      "Di sebuah gua sunyi di puncak Jabal Nur, kita menyaksikan detik pertama wahyu turun — saat sejarah manusia berbalik arah.",
    events: [
      {
        title: "Turunnya Wahyu Pertama",
        date: "Senin, 21 Ramadhan — 10 Agustus 610 M",
        body:
          "Mendekati usia 40, beliau sering beruzlah di Gua Hira. Wahyu pertama turun di usia 40 tahun 6 bulan 12 hari qamariyah, dibawa oleh Jibril dengan tiga kali pelukan dan kalimat yang menggetarkan: Iqra'. Ayat 1–3 Surah Al-'Alaq menjadi fajar pertama Islam.",
      },
      {
        title: "Dakwah Sembunyi-sembunyi",
        date: "3 Tahun Pertama — Darul Arqam",
        body:
          "As-Sabiqun Al-Awwalun — Khadijah, Zaid, Ali, Abu Bakar, dan banyak lagi — memeluk Islam dalam diam. Di rumah Al-Arqam bin Abil Arqam, ayat-ayat Allah diajarkan sembunyi-sembunyi, di tengah Mekkah yang masih dipenuhi berhala.",
      },
      {
        title: "Dakwah Terang-terangan dan Ujian Berat",
        date: "Tahun ke-4 hingga ke-10 Kenabian",
        body:
          "Ketika dakwah dibuka, Abu Lahab menjadi yang pertama menentang. Kaum muslimin yang lemah berhijrah ke Habasyah pada tahun ke-5 kenabian. Lalu datanglah pemboikotan total terhadap Bani Hasyim selama 3 tahun penuh — daun-daun pohon menjadi makanan; tangis bayi menjadi musik malam.",
      },
      {
        title: "Tahun Kesedihan ('Aamul Huzn)",
        date: "Tahun ke-10 Kenabian",
        body:
          "Pada Rajab, Abu Thalib — pelindung lahirnya — wafat. Tak lama berselang, di bulan Ramadhan, Khadijah yang setia juga menghadap Tuhannya di usia 65 tahun. Dalam tahun yang sama, beliau kehilangan dua tiang penyangga dakwah yang paling utama.",
      },
      {
        title: "Dakwah ke Thaif & Isra' Mi'raj",
        date: "Sebelum Hijrah",
        body:
          "Di Thaif beliau ditolak dengan kasar dan dilempari batu hingga sandalnya berlumur darah. Tetapi dari kesedihan itu, Allah menghibur hambaNya dengan perjalanan paling agung: Isra' ke Baitul Maqdis dan Mi'raj ke langit ketujuh — di sanalah perintah shalat 5 waktu diturunkan.",
      },
      {
        title: "Baiat Aqabah I & II",
        date: "Tahun 11–13 Kenabian",
        body:
          "Pada tahun 11 kenabian, 6 pemuda Yatsrib memeluk Islam. Setahun kemudian, 12 orang berbaiat di Aqabah I. Lalu di Aqabah II, 73 laki-laki dan 2 perempuan membaiat Rasulullah dalam kegelapan malam — janji yang membuka pintu hijrah.",
      },
    ],
  },
  {
    id: "1H",
    watermark: "1 H",
    phaseNumber: "Fase 03",
    title: "Hijrah & Membangun Madinah",
    subtitle: "Awal Tahun Hijriyah",
    period: "1 Hijriyah — 622 Masehi",
    image:
      "https://images.unsplash.com/photo-1502957291543-d85480254bf8?auto=format&fit=crop&w=1920&q=80",
    intro:
      "Bersama kita menapaki jejak hijrah — sebuah perjalanan rahasia di malam yang dingin, yang membelah sejarah menjadi sebelum dan sesudah.",
    events: [
      {
        title: "Darun Nadwah dan Pengepungan",
        date: "Malam Hijrah",
        body:
          "Di Darun Nadwah, Quraisy bersepakat membunuh Nabi dengan 11 eksekutor — satu pemuda dari setiap kabilah agar darah tertumpah merata. Namun Allah meluputkan beliau, menabur debu ke kepala mereka, dan beliau melangkah pergi tanpa terlihat.",
      },
      {
        title: "Perjalanan Hijrah dan Gua Tsur",
        date: "27 Shafar — Tahun ke-14 Kenabian",
        body:
          "Beliau meninggalkan rumah pada 27 Shafar, lalu bersama Abu Bakar bersembunyi di Gua Tsur selama 3 malam. Di sanalah turun ayat: 'Janganlah engkau bersedih, sesungguhnya Allah bersama kita.' Sebuah ketenangan yang melindungi dari mata para pemburu.",
      },
      {
        title: "Singgah di Quba'",
        date: "8 Rabi'ul Awwal 1 H — 23 September 622 M",
        body:
          "Beliau tiba di Quba' dan membangun masjid pertama dalam Islam — Masjid Quba'. Tempat sederhana ini menjadi simbol bahwa pondasi ummat dibangun dari ketakwaan, bukan dari kemegahan batu bata.",
      },
      {
        title: "Memasuki Madinah",
        date: "Hari Jumat — Bani An-Najjar",
        body:
          "Yatsrib menyambutnya dengan nyanyian rebana dan air mata kerinduan. Beliau berhenti di kediaman Bani An-Najjar, lalu membangun Masjid Nabawi. Di sinilah Muhajirin dan Anshar dipersaudarakan — sebuah persaudaraan yang melampaui darah.",
      },
      {
        title: "Syariat Azan dan Perintah Lainnya",
        date: "1–2 Hijriyah",
        body:
          "Syariat azan turun lewat mimpi Abdullah bin Zaid yang dibenarkan oleh mimpi Umar. Pada tahun 2 H, kiblat dipindahkan ke Ka'bah, kewajiban Puasa Ramadhan dan Zakat Fitrah ditetapkan, dan izin berperang turun dalam QS Al-Hajj: 39.",
      },
    ],
  },
  {
    id: "BADAR",
    watermark: "BADAR",
    phaseNumber: "Fase 04",
    title: "Mempertahankan Islam",
    subtitle: "Periode Peperangan Besar",
    period: "2 H — 5 H",
    image:
      "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1920&q=80",
    intro:
      "Di hamparan padang pasir yang tandus, kita menyaksikan iman yang sedikit menumbangkan kekuatan yang banyak.",
    events: [
      {
        title: "Perang Badar",
        date: "17 Ramadhan 2 H",
        body:
          "313 mujahidin berhadapan dengan 1.000 pasukan musyrikin Mekkah. Abu Jahal — Fir'aun ummat ini — terbunuh di medan tersebut. 14 muslim gugur sebagai syuhada, 70 musyrik tewas dan 70 lainnya tertawan. Hari itu menjadi Yaumul Furqan — hari pembeda antara haq dan bathil.",
      },
      {
        title: "Perang Uhud",
        date: "Syawwal 3 H",
        body:
          "700 muslim menghadapi 3.000 pasukan Quraisy yang haus dendam. Pasukan pemanah di Jabal Rumat tergoda meninggalkan posisi, dan posisi pasukan terbalik. 70 syuhada gugur — termasuk Hamzah sang Singa Allah dan Mush'ab bin Umair. Wajah Rasulullah sendiri terluka di hari itu.",
      },
      {
        title: "Tragedi Ar-Raji' & Bir Ma'unah",
        date: "Tahun 4 Hijriyah",
        body:
          "10 utusan Nabi dibunuh dengan tipu daya di Ar-Raji'. Tak lama, 70 ahli Al-Qur'an dibantai di Bir Ma'unah. Belum lagi kering air mata, Yahudi Bani Nadhir diusir karena pengkhianatan mereka pada Rabi'ul Awwal 4 H.",
      },
      {
        title: "Perang Ahzab / Khandaq",
        date: "Syawwal 5 H",
        body:
          "10.000 pasukan koalisi mengepung Madinah. Salman Al-Farisi mengusulkan menggali parit — strategi asing bagi bangsa Arab. Selama berhari-hari Madinah dikepung, hingga Allah menurunkan angin topan dahsyat yang menghancurkan kemah-kemah musuh dan memporak-porandakan barisan mereka.",
      },
      {
        title: "Perang Bani Quraizhah",
        date: "Dzulqa'dah 5 H",
        body:
          "Setelah pengkhianatan Yahudi Bani Quraizhah saat Khandaq, hukuman setimpal pun jatuh. Sa'ad bin Mu'adz menjadi hakim atas mereka, memutuskan dengan hukum kitab mereka sendiri — sebuah keadilan yang ditetapkan dari atas tujuh langit.",
      },
    ],
  },
  {
    id: "FATHU",
    watermark: "FATHU",
    phaseNumber: "Fase 05",
    title: "Ekspansi & Kemenangan",
    subtitle: "Hudaibiyah hingga Penaklukan Mekkah",
    period: "6 H — 8 H",
    image:
      "https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?auto=format&fit=crop&w=1920&q=80",
    intro:
      "Mari kita saksikan bagaimana kemenangan terbesar bukan datang dari pedang, melainkan dari kesabaran sebuah perjanjian.",
    events: [
      {
        title: "Perjanjian Hudaibiyah",
        date: "Dzulqa'dah 6 H",
        body:
          "Sebuah gencatan senjata 10 tahun dengan Quraisy — yang sekilas tampak merugikan, tetapi Al-Qur'an menyebutnya Fathan Mubina (kemenangan yang nyata). Buah manisnya: Khalid bin Walid dan Amru bin Al-Ash yang dahulu menjadi panglima musuh, akhirnya memeluk Islam.",
      },
      {
        title: "Surat ke Raja-raja Dunia",
        date: "Tahun 7 Hijriyah",
        body:
          "Beliau mengirim surat dakwah ke seluruh penjuru: Najasyi di Habasyah, Muqauqis di Mesir, Kisra di Persia, Heraklius di Romawi, dan banyak lagi. Sebuah deklarasi bahwa risalah ini bukan untuk satu suku, tetapi untuk seluruh ummat manusia.",
      },
      {
        title: "Perang Khaibar",
        date: "Muharram 7 H",
        body:
          "Benteng-benteng Yahudi Khaibar takluk satu per satu. Bendera diserahkan kepada Ali bin Abu Thalib — 'seorang yang dicintai Allah dan Rasul-Nya'. Di sinilah pula terjadi insiden daging beracun dari Zainab binti Al-Harits yang efeknya kelak terasa hingga akhir hayat Rasulullah.",
      },
      {
        title: "Umrah Qadha' & Perang Mu'tah",
        date: "Dzulqa'dah 7 H — Jumadil Awwal 8 H",
        body:
          "Umrah Qadha' dilaksanakan di Dzulqa'dah 7 H — sebuah pemenuhan janji. Lalu di Mu'tah, 3.000 muslim berhadapan dengan 200.000 pasukan Romawi dan sekutunya. Tiga panglima — Zaid, Ja'far, dan Ibnu Rawahah — gugur berurutan, sebelum Khalid memimpin penarikan strategis yang menyelamatkan pasukan.",
      },
      {
        title: "Fathu Makkah",
        date: "10 Ramadhan 8 H",
        body:
          "Karena Quraisy melanggar perjanjian Hudaibiyah, beliau memimpin 10.000 sahabat memasuki Mekkah. 360 berhala di sekitar Ka'bah dihancurkan tanpa setetes darah pun yang tertumpah. Di hari itu beliau berkata: 'Pergilah, kalian semua bebas.' Abu Sufyan pun mengucapkan dua kalimat syahadat.",
      },
    ],
  },
  {
    id: "11H",
    watermark: "11 H",
    phaseNumber: "Fase 06",
    title: "Akhir Hayat & Kesempurnaan Risalah",
    subtitle: "Dari Hunain hingga Wafatnya Rasulullah",
    period: "8 H — 11 H",
    image:
      "https://images.pexels.com/photos/34731514/pexels-photo-34731514.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    intro:
      "Kita sampai pada babak terakhir — di mana risalah disempurnakan, dan kekasih Allah pun kembali ke pangkuan Tuhannya.",
    events: [
      {
        title: "Perang Hunain & Thaif",
        date: "Tahun 8 Hijriyah",
        body:
          "Setelah Fathu Makkah, suku Hawazin dan Tsaqif berhimpun untuk melawan. Sempat goyah di awal pertempuran karena banyaknya jumlah, kemenangan akhirnya diraih dengan 6.000 tawanan dan harta rampasan yang melimpah — yang kemudian dibagikan untuk meluluhkan hati para muallaf.",
      },
      {
        title: "Perang Tabuk",
        date: "Tahun 9 Hijriyah",
        body:
          "30.000 muslim berangkat di musim panas yang mencekik menuju perbatasan Romawi. Mendengar gerakan ini, Romawi gentar dan bersedia berdamai dengan membayar jizyah — peperangan tidak terjadi, tetapi keagungan Islam telah disaksikan dunia.",
      },
      {
        title: "Haji Wada' — Haji Perpisahan",
        date: "Dzulqa'dah 10 H",
        body:
          "Beliau berangkat 4 hari sebelum akhir Dzulqa'dah, dan berpidato di Arafah di hadapan 124.000 hingga 144.000 kaum muslimin. 'Sesungguhnya darah, harta, dan kehormatanmu haram atas sesamamu.' Di sanalah turun ayat penyempurnaan agama: hari ini telah Aku sempurnakan agamamu untukmu.",
      },
      {
        title: "Wafatnya Rasulullah ﷺ",
        date: "Senin, 12 Rabi'ul Awwal 11 H",
        body:
          "Sakit beliau dimulai pada 29 Shafar 11 H. Selama 13–14 hari beliau tetap mengimami shalat — hingga 4 hari sebelum wafat. Beliau pulang ke rahmat Allah pada Senin, 12 Rabi'ul Awwal 11 H, di usia 63 tahun lebih 4 hari, dan dimakamkan di kamar 'Aisyah. Madinah menangis; matahari pun seolah meredup.",
      },
    ],
  },
];
